import { cloneElement, useMemo } from 'react';
import cn from 'classnames';
import { Badge, Button, IconButton, TextButton, Typography } from 'seagull';
import { Download, WideArrowBackward } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { getAgreementPdfUrl } from "../../business-logic/relationshipLogic";
import { useIoContext, useStore } from "../../contexts";
import { relationshipModel } from "../../models";
import { selectors } from "../../store/state-selectors";
import BrandingControllers from "../clientOb/BrandingControllers/BrandingControllers";
import { reasonToText } from "../clientOb/ClientOnboarding.utils";
import { OverrideBranding } from "../clientOb/CobBrandingContext";
import { useCobConfig } from "../clientOb/CobConfigContext";
import { useResponsive } from "../contexts";
import { FooterErrorMessage } from "./FooterErrorMessage";
import styles from "./StepPage.module.scss";
import { TextBox } from "./TextBox";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GetStepPageTestIds = dataTestId => getTestIds(dataTestId);
export function StepPage(_ref) {
  let {
    children,
    header,
    primaryBtn,
    onBackBtnClick,
    showError,
    disabledReason,
    contentClassName,
    errorMessage,
    showDownloadAsPDFButton = false,
    disableDownloadAsPDFButton = false,
    dataTestId,
    withinFooter
  } = _ref;
  const worksAt = useStore(selectors.user.business);
  const {
    isMobile,
    isDesktop
  } = useResponsive();
  const {
    relationship,
    isSetupBrand
  } = useCobConfig();
  const {
    openNewTab
  } = useIoContext();
  const pdfHost = useStore(selectors.pdfHost);
  const {
    StepPageTestIds
  } = useMemo(() => GetStepPageTestIds(dataTestId), [dataTestId]);
  const onDownloadPDF = () => {
    openNewTab(getAgreementPdfUrl(relationshipModel.id(relationship), pdfHost));
  };
  if (primaryBtn.type === Button) {
    primaryBtn = /*#__PURE__*/cloneElement(primaryBtn, {
      fluid: true
    });
  }
  primaryBtn = /*#__PURE__*/cloneElement(primaryBtn, {
    'data-testid': StepPageTestIds.NextButton()
  });
  const wrappedPrimaryBtn = isDesktop ? /*#__PURE__*/_jsx("div", {
    className: styles.ctaWrapper,
    children: primaryBtn
  }) : primaryBtn;
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": StepPageTestIds.Root(),
    className: cn(styles.root, {
      [styles.mobile]: isMobile,
      [styles.desktop]: isDesktop
    }),
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.headerAndContent,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.header,
        children: /*#__PURE__*/_jsxs(TextBox, {
          className: styles.headerTextBox,
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.title,
            children: [isDesktop && onBackBtnClick && /*#__PURE__*/_jsx(IconButton, {
              skin: "transparent",
              onClick: onBackBtnClick,
              "data-testid": StepPageTestIds.BackButton(),
              children: /*#__PURE__*/_jsx(WideArrowBackward, {})
            }), /*#__PURE__*/_jsx(Typography, {
              variant: isMobile ? 'h6' : 'h4',
              weight: "normal",
              "data-testid": StepPageTestIds.Header(),
              children: header
            }), relationship.isSample && /*#__PURE__*/_jsx(Badge, {
              outlined: true,
              children: "Test agreement"
            })]
          }), showDownloadAsPDFButton && /*#__PURE__*/_jsx(TextButton, {
            onClick: onDownloadPDF,
            className: styles.downloadButton,
            prefixIcon: /*#__PURE__*/_jsx(Download, {
              height: 16,
              width: 16
            }),
            underline: "none",
            variant: "paragraph2",
            weight: "light",
            "data-testid": StepPageTestIds.DownloadPdf(),
            skin: "secondary",
            disabled: disableDownloadAsPDFButton,
            children: "Download as PDF"
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: cn(styles.contentWrapper, contentClassName),
        "data-testid": StepPageTestIds.Content(),
        children: /*#__PURE__*/_jsx("div", {
          className: styles.content,
          children: children
        })
      })]
    }), isSetupBrand && worksAt && /*#__PURE__*/_jsx(OverrideBranding, {
      className: styles.setupBrandContainer,
      testid: "setup-brand-section",
      children: /*#__PURE__*/_jsx(BrandingControllers, {
        worksAt: worksAt
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.footer,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.primaryBtnContainer,
        children: [errorMessage ? /*#__PURE__*/_jsx(FooterErrorMessage, {
          vertical: isMobile,
          showError: showError !== null && showError !== void 0 ? showError : false,
          errorMessage: errorMessage,
          "data-testid": StepPageTestIds.Error(),
          children: wrappedPrimaryBtn
        }) : wrappedPrimaryBtn, disabledReason && /*#__PURE__*/_jsx(Typography, {
          "data-testid": "disabled-reason-".concat(disabledReason),
          className: styles.disabledReason,
          children: reasonToText[disabledReason]
        })]
      }), withinFooter && /*#__PURE__*/_jsx("div", {
        className: styles.withinFooter,
        children: withinFooter
      })]
    })]
  });
}